export default {
  data: [],
  loading: true,
};
